/**
 * js的常量就在这里
 */
export default {
  defaultTdBackgroundColor: '#FFFFFF',
  defaultTitleTdBackgroundColor: '#F6F6F6'
}
